import classes from './login-stage-two-lyra.module.scss';

import { Box } from '@mui/material';
import { CcfButton, CcfTypography, useTranslator } from '@nice-ccf/ui-controls';

import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';

export interface LoginResetPasswordLyraProps {
  onBackToSignIn: () => void;
}

/**
 * "Check your email" screen shown after a password reset is requested, styled for the Lyra design
 * @param props - LoginResetPasswordLyraProps
 * @example <LoginResetPasswordLyra />
 * @returns
 */
export function LoginResetPasswordLyra({
  onBackToSignIn,
}: LoginResetPasswordLyraProps) {
  const [translate] = useTranslator();

  return (
    <Box className={classes.forgotPasswordScreen}>
      <span className={classes.emailIconCircle}>
        <MarkEmailReadOutlinedIcon fontSize="medium" />
      </span>
      <CcfTypography className={classes.checkEmailTitle}>
        {translate('checkYourEmailTitle')}
      </CcfTypography>
      <CcfTypography className={classes.checkEmailSubtitle}>
        {translate('checkYourEmailSubtitle')}
      </CcfTypography>
      <CcfButton
        variant="contained"
        fullWidth
        className={classes.continueButton}
        onClick={onBackToSignIn}
      >
        {translate('backToSignInButtonText')}
      </CcfButton>
      <CcfButton variant="outlined" fullWidth className={classes.backButton}>
        {translate('resendEmailButtonText')}
      </CcfButton>
    </Box>
  );
}

export default LoginResetPasswordLyra;
